export default {"src":"/_next/static/media/school.2e527343.svg","height":70,"width":70,"blurWidth":0,"blurHeight":0};